import { Injectable, OnInit, ViewChild } from "@angular/core";
import { BaseController } from "../helpers/base.controller";
import { DataTable, LazyLoadEvent } from 'primeng/primeng';
import * as _ from 'underscore';
import { ComponentsModule } from "../components/components.module";
import { AppModule } from "../app.module";
import { Subscription } from "rxjs/Subscription";
import { CapitalizeFirstPipe } from "../shared/pipes/capitalize-first.pipe";
import { BaseService } from "../services";

@Injectable()
export class PesquisaBaseController extends BaseController {
    totalRecords: number;
    dados: any;
    show: boolean = false;
    paginaAtual: any = 0;
    tamanhoAtual: any = 10;
    subFiltro: Subscription;
    subFiltroPag: Subscription;
    subAtivar: Subscription;
    subInativar: Subscription;

    @ViewChild(DataTable) dataTable: DataTable;
    constructor(_service:BaseService) {
        super(_service)
    }

    ngOnInit() {
        this.pesquisarGrid(this.model);
    }

    ngAfterViewInit() {
        var msg = localStorage.getItem('msgSucesso');
        if (msg) {
            this._notificationsService.Sucesso(this.translate.instant("controllerBase.sucesso"), msg);
            localStorage.removeItem('msgSucesso');
        }
    }

    pesquisarGrid(form) {
        this.carregarLoading();
        this.model = form;
        this.pesquisar();
        this.setCurrentPage(1);
    }

    pesquisar() {
        this.subFiltro = this.service.getFiltro(this.service._api,this.model, this.paginaAtual, this.tamanhoAtual).subscribe(result => {
            this.show = true;
            this.dados = result.data;
            this.totalRecords = result.total;
            this.fecharLoading();
        });
    }
    
    //Grid Configs
    setCurrentPage(n: number) {
        if (this.dataTable) {
            let paging = {
                first: ((n - 1) * this.dataTable.rows),
                rows: this.dataTable.rows
            };
            this.dataTable.paginate();
        }
    }

    loadData(event: LazyLoadEvent) {
        if (this.paginaAtual != event.first) {
            this.paginaAtual = event.first;
            this.tamanhoAtual = event.rows;

            this.subFiltroPag = this.service.getFiltro(this.service._api,this.model, this.paginaAtual, this.tamanhoAtual).subscribe(result => {
                this.dados = result.data;
            });
        }
    }

    //Atualizar

    ativarDialog(id) {
        let ativar = this.translate.instant("controllerBase.ativar")
        let ativarCase = new CapitalizeFirstPipe().transform(ativar);
        let msgConfirm = this.translate.instant("controllerBase.mensagemAtivarInativar", { value: ativar });
        this._dialog.confirm(ativarCase, msgConfirm + '?', () => {
            this.subAtivar = this.service.ativar(id).subscribe(result => {
                this.pesquisar();
                let ativado = this.translate.instant("controllerBase.ativado")
                let msgSucesso = this.translate.instant("controllerBase.registroAtivadoInativoComSucesso", { value: ativado });
                this._notificationsService.Sucesso(new CapitalizeFirstPipe().transform(ativar), msgSucesso + ".");
            });
        })
    }
    inativarDialog(id) {
        let inativar = this.translate.instant("controllerBase.inativar")
        let inativarCase = new CapitalizeFirstPipe().transform(inativar);
        let msgConfirm = this.translate.instant("controllerBase.mensagemAtivarInativar", { value: inativar });
        this._dialog.confirm(new CapitalizeFirstPipe().transform(inativar), msgConfirm + '?', () => {
            this.subInativar = this.service.inativar(id).subscribe(result => {
                this.pesquisar();
                let inativado = this.translate.instant("controllerBase.inativado")
                let msgSucesso = this.translate.instant("controllerBase.registroAtivadoInativoComSucesso", { value: inativado });
                this._notificationsService.Sucesso(inativarCase, msgSucesso + ".");
            });
        })
    }

    copiado() {
        this._notificationsService.Sucesso(this.translate.instant("controllerBase.mensagem"), this.translate.instant("controllerBase.mensagemCopiadaAreaTransferencia") + ".");
    }

    carregarLoading() {
        this._loading.carregar();
    }

    fecharLoading() {
        this._loading.fecharTodos();
    }

    ngOnDestroy() {
        if (this.subFiltro) this.subFiltro.unsubscribe();
        if (this.subFiltroPag) this.subFiltroPag.unsubscribe();
        if (this.subAtivar) this.subAtivar.unsubscribe();
        if (this.subInativar) this.subInativar.unsubscribe();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/helpers/pesquisa.base.controller.ts